// src/views/auth/Auth.jsx
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { doLogin } from '../../context/slices/session/thunks'
import { toast } from 'react-toastify'
import { logoColor } from '../../utils'

export default function Auth({
  btnColor,
  iconUser,
  iconPassword,
}) {
  const dispatch = useDispatch()
  const [session, setSession] = useState({
    p_username: '',
    p_password: '',
  })
  const [loadSubmit, setLoadSubmit] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target

    if (!form.checkValidity()) {
      form.classList.add('was-validated')
      return
    }

    form.classList.remove('was-validated')
    setLoadSubmit(true)

    dispatch(doLogin({ data: {
      ...session,
      always: () => setLoadSubmit(false)
    }, toast }))
  }

  return (
    <div className="head-dash-login">
      <div className="head-dash-login-box">
        <div className="card border-0 shadow-sm head-dash-login-content">
          <div className="card-body p-4 p-md-5">
            {/* Logo */}
            <div className="text-center mb-4">
              <img
                src={logoColor()}
                alt="Logo"
                className="head-dash-login-logo mb-3"
                style={{ maxHeight: 60 }}
              />
              <h5 className="mb-1 fw-bold">Inicia sesión</h5>
              <p className="text-muted small mb-0">
                Accede a tu cuenta para gestionar tus entradas y compras.
              </p>
            </div>

            {/* Formulario */}
            <form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="needs-validation"
              noValidate
            >
              <div className="mb-3">
                <label className="form-label small text-muted mb-1">
                  Nombre de usuario
                </label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text bg-light border-end-0">
                    <i className={iconUser} />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Ingresa tu usuario"
                    required
                    value={session.p_username}
                    onChange={(e) =>
                      setSession({
                        ...session,
                        p_username: e.currentTarget.value,
                      })
                    }
                  />
                  <div className="invalid-feedback">
                    Indica tu nombre de usuario.
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label small text-muted mb-1">
                  Contraseña
                </label>
                <div className="input-group input-group-lg">
                  <span className="input-group-text bg-light border-end-0">
                    <i className={iconPassword} />
                  </span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control border-start-0 border-end-0"
                    placeholder="Ingresa tu contraseña"
                    required
                    value={session.p_password}
                    onChange={(e) =>
                      setSession({
                        ...session,
                        p_password: e.currentTarget.value,
                      })
                    }
                  />
                  <button
                    type="button"
                    className="input-group-text bg-light border-start-0"
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{ cursor: 'pointer' }}
                    aria-label={
                      showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'
                    }
                  >
                    <i className={showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'} />
                  </button>
                  <div className="invalid-feedback">
                    Ingresa tu contraseña.
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    id="remember_me"
                    className="form-check-input"
                  />
                  <label
                    htmlFor="remember_me"
                    className="form-check-label small text-muted"
                  >
                    Recordarme en este dispositivo
                  </label>
                </div>

                {/* Si en algún momento quieres link de "Olvidé mi contraseña" */}
                {/* <button type="button" className="btn btn-link btn-sm p-0">
                  ¿Olvidaste tu contraseña?
                </button> */}
              </div>

              <div className="d-grid">
                <button
                  type="submit"
                  className={`btn btn-${btnColor} btn-lg d-flex justify-content-center align-items-center`}
                  disabled={loadSubmit}
                >
                  {loadSubmit ? (
                    <>
                      <i className="fa fa-circle-notch fa-spin me-2" />
                      Validando credenciales...
                    </>
                  ) : (
                    <>
                      <i className="fa fa-sign-in-alt me-2" />
                      Iniciar sesión
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          {/* Footer pequeño opcional */}
          <div className="card-footer bg-white border-0 text-center py-3">
            <small className="text-muted">
              ¿Problemas para ingresar? Contacta al soporte del evento.
            </small>
          </div>
        </div>
      </div>
    </div>
  )
}

Auth.defaultProps = {
  brand: '',
  btnColor: 'primary',
  iconUser: 'fa fa-user',
  iconPassword: 'fa fa-lock',
}
